import { render } from "./ModalCashRegister.vue?vue&type=template&id=08c934e7"
import script from "./ModalCashRegister.vue?vue&type=script&lang=js"
export * from "./ModalCashRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__